
import { defineComponent, reactive, toRefs, watch, computed } from 'vue'
import { getCurTab } from '@/composables/use-function'
import tabList from '@/components/common/tab/tab-list.vue'
import customBtn from '@/components/common/btn/custom-btn.vue'
import seriesDiscountList from '@/components/local-super-buy/series-discount-list.vue'
import switchBtn from '@/components/common/btn/switch-btn.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { fetchSerialDiscountList, countAd } from '@/http/api'
import { setTxtLength } from '@/utils/handle-text'
export default defineComponent({
  name: '',
  props: ['locationInfo', 'columnImgUrl'],
  components: {
    tabList,
    customBtn,
    seriesDiscountList,
    switchBtn,
  },
  emits: ['openCarSideBar'],
  setup(props, { emit }) {
    const store = useStore()
    const route = useRoute()
    const data = reactive({
      activityInfo: computed(() => store.state.activityInfo),
      locationInfo: computed(() => store.state.locationInfo),
      carInfo: computed(() => store.state.carInfo),
      queryObj: {
        actId: -1,
        brandId: -1, // 当期品牌Id
        cityId: -1,
        priceRangeId: -1,
        pageNo: 1,
        pageSize: 5,
      },
      discountList: [] as any,
      noResult: 1, // 是否查询无结果: 1-是,0-否
      recommendNoResult: 0, // 是否有无荐车系
      total: 1,
      isShowLoadMore: false,
      isShowLoading: true, // 数据加载loading
      curBrandTabIndex: 0,
      curPriceTabIndex: 0,
      switchVal:Number(route.query.switchBtn) || 0,
    })
    // 定位信息
    watch(
      () => data.locationInfo,
      (nVal, oVal) => {
        if (nVal.cityId !== oVal.cityId) {
          data.queryObj.cityId = nVal.cityId
          data.queryObj.pageNo = 1
          data.discountList = []
          methods.getSerialDiscountList(true)
        }
      },
    )
    // 活动信息
    watch(
      () => data.activityInfo,
      (nVal, oVal) => {
        if (nVal !== oVal) {
          data.queryObj.brandId = nVal.brands[0].brandId
          data.queryObj.priceRangeId = nVal.price[0].priceRangeId
          methods.getSerialDiscountList(true)
        }
      },
    )
    // 选车信息
    watch(
      () => data.carInfo,
      (nVal, oVal) => {
        if (nVal !== oVal) {
          console.log('nVal===',nVal)
          data.queryObj.brandId = nVal.carBrand.id
          data.queryObj.pageNo = 1
          data.curBrandTabIndex = getCurTab(nVal.carBrand.id, brandList.value) // 修改当前tab
          data.discountList = []
          methods.getSerialDiscountList(true)
        }
      },
    )
    const brandList: any = computed(() => {
      if (!data.activityInfo.brands) return
      return data.activityInfo.brands.map((brand: any) => {
        return {
          ...brand,
          type: 'brandList',
          showName: brand.brand,
        }
      })
    })
    const priceList = computed(() => {
      if (!data.activityInfo.price) return
      return data.activityInfo.price.map((pItem: any) => {
        return {
          ...pItem,
          type: 'priceList',
          showName: pItem.priceMsg,
        }
      })
    })
    const methods = {
      // 获取车系优惠详情列表
      async getSerialDiscountList(isReGet?: boolean) {
        if (
          !route.query.actId ||
          data.queryObj.brandId === -1 ||
          data.queryObj.cityId === -1 ||
          data.queryObj.brandId === -1
        ) {
          return
        }
        data.isShowLoading = true
        const res: any = await fetchSerialDiscountList({
          actId: route.query.actId,
          brandId: data.queryObj.brandId,
          cityId: data.locationInfo.cityId,
          priceRangeId: data.queryObj.priceRangeId,
          pageNo: data.queryObj.pageNo,
          pageSize: 5,
          lessPurchaseTax: 0,
        })
        data.isShowLoading = false
        if (res.code === 200) {
          if (isReGet) {
            data.discountList = [].concat(res.data.list)
          } else {
            data.discountList.push(...res.data.list)
          }
          data.discountList = data.discountList.map((item: any) => {
            item.serialOriginalName = item.serialGroupName
            item.serialGroupName = setTxtLength(item.serialGroupName, 6)
            return item
          })
          data.noResult = res.data.noResult
          data.recommendNoResult = res.data.recommendNoResult
          data.total = res.data.total
        }
      },
      // 打开品牌侧边栏
      openCarSideBar() {
        // 栏目名
        emit('openCarSideBar', {
          name: 'local-super-buy',
        })
        countAd(6312)
      },
      // 修改tab
      changeTabItem(curTabIndex: any, tabItem: any) {
        if (tabItem.type === 'brandList') {
          data.queryObj.brandId = tabItem.brandId
          data.curBrandTabIndex = curTabIndex
          if (data.curBrandTabIndex === 0) {
            // 选中推荐
            data.curPriceTabIndex = curTabIndex
          }
        } else if (tabItem.type === 'priceList') {
          data.queryObj.priceRangeId = tabItem.priceRangeId
          data.curPriceTabIndex = curTabIndex
        }
        data.queryObj.pageNo = 1
        data.discountList = []
        methods.getSerialDiscountList(true)
      },
      // 改变Switch开关
      changeSwith(flag:boolean){
        if(flag){
          data.switchVal = 1
        }else{
          data.switchVal = 0
        }
        data.queryObj.pageNo = 1
        methods.getSerialDiscountList(true)
      },
      // 加载更多
      getMoreData() {
        data.queryObj.pageNo = data.queryObj.pageNo + 1
        methods.getSerialDiscountList()
      },
    }
    return {
      ...toRefs(data),
      ...methods,
      brandList,
      priceList,
    }
  },
})
